import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
export default {
  name: "App",
  components: {},
  props: ["prorData"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      uploadUrl: this.$http.defaults.baseURL + "/serveFile/upload",
      uploadHeader: {},
      fileUploadData: {},
      // 文件上传额外参数
      imgUploadData: {},
      // 流程图上传额外参数
      useId: "",
      // 使用说明id
      fileListObj: [],
      // 存储所有上传文件 id、name、url
      flowForm: {
        name: "",
        unit: "",
        phone: "",
        time: "",
        site: ""
      },
      useForm: {
        description: "",
        fileList: [],
        fileIds: [],
        imgUrl: "",
        imgId: "",
        question: []
      },
      shortData: null,
      // 保存 获取详情之后的数据，用于判断是新增还是更像
      flowRules: {
        unit: [{
          required: false,
          message: "请输入负责单位",
          trigger: "blur"
        }],
        phone: [{
          required: false,
          message: "请输入联系电话",
          trigger: "blur"
        }],
        name: [{
          required: false,
          message: "请输入联系人",
          trigger: "blur"
        }],
        time: [{
          required: false,
          message: "请选择办理时间",
          trigger: "blur"
        }],
        site: [{
          required: false,
          message: "请输入办理地点",
          trigger: "blur"
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters(["userToken"])),
  created: function created() {},
  mounted: function mounted() {
    this.uploadHeader = {
      token: this.userToken,
      Authorization: "bearer " + this.$keycloak.token
    };
  },
  destroyed: function destroyed() {},
  methods: {
    // 刷新表单
    refreshForm: function refreshForm() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs["flowForm"].resetFields();

        _this.$refs["useForm"].resetFields();
      });
    },
    // 点击 提交
    submitForm: function submitForm(formName) {
      var _this2 = this;

      if (!this.prorData.serveId) {
        this.$message.warning("请先新增服务基本信息！");
        return;
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this2.useForm.imgId === "" && _this2.useForm.imgUrl) {
            _this2.$refs.imgUpload.submit(); // 上传图标

          } else {
            _this2.serveFn();
          }
        } else {
          return false;
        }
      });
    },
    // 提交方法
    serveFn: function serveFn() {
      var _this3 = this;

      // 传入参数
      var data = {
        serveInstructions: {
          id: this.useId,
          contactName: this.flowForm.name,
          contactPhone: this.flowForm.phone,
          handleTime: this.flowForm.time,
          handleAddr: this.flowForm.site,
          chargeDept: this.flowForm.unit,
          serveId: this.prorData.serveId,
          serveInstruction: this.useForm.description
        },
        fileIds: [],
        processPhotoId: this.useForm.imgId,
        serveQAList: []
      };
      this.useForm.question.forEach(function (e) {
        data.serveQAList.push({
          id: e.id,
          question: e.question,
          answer: e.answer,
          serveId: _this3.prorData.serveId
        });
      });
      this.fileListObj.forEach(function (e) {
        data.fileIds.push(e.id);
      }); // 判断 更新 新增

      if (this.shortData) {
        this.updateFn(data);
        return;
      }

      this.$http.post("/instruction/add", data).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode === 0) {
          _this3.$message.success("使用说明保存成功！");
        }

        _this3.$emit("closeFn");
      }).catch(function () {});
    },
    // 修改 更新
    updateFn: function updateFn(data) {
      var _this4 = this;

      this.$http.post("/instruction/update", data).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode === 0) {
          _this4.$message.success("使用说明更新成功！");
        }

        _this4.$emit("closeFn");
      }).catch(function () {});
    },
    // 查询 使用详情
    getInfoFn: function getInfoFn() {
      var _this5 = this;

      this.$http.get("/instruction/detail?serveId=" + this.prorData.serveId).then(function (_ref3) {
        var data = _ref3.data;
        _this5.shortData = data.resData;

        if (data.resCode === 0) {
          var newData = data.resData;
          var qaData = newData.qa;
          var serveData = newData.serveFile;
          var flowData = data.resData.serveInstructions;
          _this5.useId = flowData.id;
          _this5.flowForm.name = flowData.contactName;
          _this5.flowForm.unit = flowData.chargeDept;
          _this5.flowForm.phone = flowData.contactPhone;
          _this5.flowForm.time = flowData.handleTime;
          _this5.flowForm.site = flowData.handleAddr;
          _this5.useForm.description = flowData.serveInstruction;
          serveData.forEach(function (e) {
            _this5.useForm.fileList.push({
              name: e.relatedFileName,
              url: e.fileUrl
            });

            _this5.useForm.fileIds.push(e.id);

            _this5.fileListObj.push({
              id: e.id,
              name: e.relatedFileName,
              url: e.fileUrl
            });
          });
          _this5.useForm.imgUrl = newData.processPhoto ? newData.processPhoto.fileUrl : "";
          _this5.useForm.imgId = newData.processPhoto ? newData.processPhoto.id : "";
          qaData.forEach(function (e) {
            _this5.useForm.question.push({
              id: e.id,
              question: e.question,
              answer: e.answer,
              serveId: e.serveId
            });
          });
        } else if (data.resCode === -1003) {
          _this5.$message.warning("该服务暂无使用说明！");
        }
      }).catch(function () {});
    },
    // 新增问题
    addQuestion: function addQuestion() {
      var n = this.useForm.question.length + 1;
      this.useForm.question.push({
        id: n,
        title: "",
        content: "",
        answer: "",
        serveId: this.prorData
      });
    },
    // 删除问题
    delQuestion: function delQuestion(index) {
      this.useForm.question.splice(index, 1);
    },
    // 上传文件
    fileChange: function fileChange(file, fileList) {
      var isJPG = file.raw.type === "text/plain" || file.raw.type === "application/vnd.ms-excel" || file.raw.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      var isLt2M = file.size / 1024 < 1024;

      if (!isJPG) {
        this.$message.error("上传文件只能是 .txt, .docx, .xls 格式文件!");
        return;
      }

      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 1MB!,请重新上传。");
        return;
      }

      this.useForm.fileList = fileList; // 最大上传三个
      // this.fileList = fileList.slice(-3);
    },
    // 流程图 上传成功
    fileSuccess: function fileSuccess(response, file) {
      var _this6 = this;

      this.$nextTick(function () {
        _this6.useForm.fileIds.push(response.resData[0]);

        _this6.fileListObj.push({
          id: response.resData[0],
          name: file.name,
          url: ""
        });
      });
    },
    // 流程图  选中流程图(用于选中未提交时，显示图片)
    onChange: function onChange(file) {
      var arr = [];
      var isPNG = file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      var isLt2M = file.size / 1024 < 1024;

      if (!isPNG) {
        this.useForm.imgUrl = "";
        this.$message.error("只支持上传.JPG、.PNG文件！");
        return;
      }

      if (!isLt2M) {
        this.useForm.imgUrl = "";
        this.$message.error("上传流程图大小不能超过 1MB!,请重新上传。");
        return;
      } // 变更图标之后重新赋值，保持只有有个图标


      arr.push(file);
      this.$refs.imgUpload.uploadFiles = arr;
      this.useForm.imgId = ""; // 选择新图片，id要为空

      this.useForm.imgUrl = URL.createObjectURL(file.raw);
    },
    // 流程图 上传成功
    onSuccess: function onSuccess(response) {
      var _this7 = this;

      this.$nextTick(function () {
        _this7.useForm.imgId = response.resData[0];

        _this7.serveFn();
      });
    },
    // 流程图  上传错误
    onError: function onError() {
      var _this8 = this;

      this.$nextTick(function () {
        _this8.form.imgUrl = "";

        _this8.$message.error("网络错误！");
      });
    },
    // 服务文件上传
    // 移除文件
    fileRemove: function fileRemove(file) {
      this.fileListObj.splice(this.fileListObj.findIndex(function (item) {
        return item.name === file.name;
      }), 1);
      this.$message.success("文件 " + file.name + " 移除成功！");
    },
    // 文件移除提示
    fileBeforeRemove: function fileBeforeRemove(file) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    handleExceed: function handleExceed() {
      this.$message.warning("只支持上传 3 个文件");
    }
  },
  watch: {
    prorData: {
      handler: function handler() {
        var _this9 = this;

        this.$nextTick(function () {
          if (_this9.prorData.type === "1") {
            _this9.getInfoFn();
          }
        });
      },
      immediate: true
    }
  },
  filters: {}
};